// extracted by mini-css-extract-plugin
module.exports = {"CheckboxGroup__checkbox":"CheckboxGroup_CheckboxGroup__checkbox__zIBQs","FormCheckboxGroup__error":"CheckboxGroup_FormCheckboxGroup__error__3NIXA"};